/// <reference path="../../../teva/moveable/moveable.ts" />
/// <reference path="../../../teva/navigation/navigation.ts" />
/// <reference path="../../../teva/htmlhelpers/htmlhelpers.ts" />
/// <reference path="../forms/forms.ts" />
/// <reference path="../navigation/navigation.ts" />
/// <reference path="../externalprovider/externalprovider.ts" />
/// <reference path="../resources/resources.ts" />
/// <reference path="../common/common.ts" />

namespace OfficeGuy {
    interface HTMLDialogParams {
        HTML: any;
        Title?: string;
        HidingEvent?: any;
        HideEvent?: any;
        Buttons?: any;
        EnterEvent?: any;
        ShowSubmitButton?: any;
        Simple?: any;
    }

    interface HTMLCloneDialog {
        Title?: string;
        Selector: any;
        ReplaceModal?: boolean;
        Simple?: any;
    }

    interface HTMLGetDialogParams {
        URL: string;
        Data?: any;
        Method?: string;
        FullURL?: string;
        Title?: string;
        LoadedEvent?: any;
        ConvertToAjax?: boolean;
        ConvertToAjax_PreRenderEvent?: any;
        Buttons?: any;
        ReplaceModal?: boolean;
        PushState?: boolean;
        ModalID?: any;
        HideEvent?: any;
        Simple?: any;
    }

    interface ConfirmDialogParams {
        Title: string;
        Message: any;
        ConfirmText?: string;
        ConfirmEvent: any;
        ConfirmClass?: string;
        CancelAllowed?: boolean;
        CancelEvent?: any;
        CancelClass?: string;
        CancelText?: string;
        HidingEvent?: any;
        HideEvent?: any;
        Simple?: boolean;
    }

    interface InputDialogParams {
        Title: string;
        Message?: string;
        ConfirmText?: string;
        Remark?: string;
        RemarkHTML?: boolean;
        Text?: string;
        TextHTML?: boolean;
        ConfirmEvent: any;
        Buttons?: any;
        DefaultValue?: string;
        InputClass?: string;
        Simple?: any;
    }

    interface CreateModalParams {
        Title: any;
        Body?: any;
        Buttons?: any;
        EnterEvent?: any;
        ShownEvent?: any;
        HidingEvent?: any;
        HideEvent?: any;
        DisableAutoShow?: boolean;
        History_Type?: string;
        History_Data?: any;
        PushState?: boolean;
        ModalID?: any;
        Simple?: boolean;
    }

    export class Modals {
        static EnableBack: boolean = false;
        static VisibleModals = new Array();
        static ModalIndex: number = 0;
        static ZIndex: number = 1050;

        static PageLoad(): void {
            Modals.EnableBack = false;
            if ($(".modal:visible").length == 0)
                $(".modal-backdrop").remove();
            $(document).trigger("click.multiplevalues");
        }

        static Init(): void {
            var DragCount = 0;
            $(document.body)
                .off("mousedown.modal").on("mousedown.modal", function () {
                    DragCount = 0;
                })
                .off("mousemove.modal").on("mousemove.modal", function () {
                    DragCount++;
                })
                .off("click.modal").on("click.modal", function (Event) {
                    if (Modals.VisibleModals.length == 0 || DragCount > 10)
                        return;

                    var $Modal = $(Modals.VisibleModals[Modals.VisibleModals.length - 1]);
                    var $Target = $(Event.target);
                    if ($Target.closest($Modal.find(".modal-dialog:first")).length != 0)
                        return;
                    if ($Target.hasClass("og-notification-fixed-remove"))
                        return;
                    if ($Target.closest(".og-navigation-bar, .teva-selectbox-mobile, .teva-selectbox-container, .teva-selectbox-search-terms, .teva-selectbox-search").length > 0)
                        return;

                    if (<any>new Date() - <any>$Modal.data("modal-createdate") < 100)
                        return;
                    if ($(".og-loading").length > 0)
                        return;

                    Modals.Hide($Modal);
                    Event.preventDefault();
                    Event.stopImmediatePropagation();
                    Event.stopPropagation();
                });
            $(document).on("keyup.escape", null, "esc", Modals.KeyupPressed);
        }
        static KeyupPressed(Event) {
            if (Modals.VisibleModals.length == 0)
                return true;

            var $ModalToRemove = $(Modals.VisibleModals[Modals.VisibleModals.length - 1]);
            Modals.Hide($ModalToRemove);
            Event.preventDefault();
            Event.stopImmediatePropagation();
            Event.stopPropagation();
            return false;
        }

        static UpdateTitle(Modal, Title): void {
            var $Element = $(".modal-content-title-text", Modal);
            $Element.empty();
            if (Title == null)
                return;
            if (typeof (Title) == "string")
                $Element[0].innerHTML = Title;
            else
                Title($Element);
        }
        static UpdateBody(Modal, Body): void {
            var $Element = $(".modal-body", Modal);
            $Element.empty();
            if (Body == null)
                return;
            if (typeof (Body) == "string")
                $Element.append($(document.createElement('div')).html(Body));
            else if (Body instanceof jQuery)
                $Element.append(<JQuery>Body);
            else
                Body($Element);
        }

        static Show($Modal): void {
            if ($Modal.length != 1)
                return;

            var Params = <CreateModalParams>$Modal.data("modal-params");
            if (Params == null)
                return;

            var $Backdrop = $
                (document.createElement('div')
                    .addClass("modal-backdrop"))
                .css("z-index", Teva.Positioning.GetNextZIndex());

            $Modal
                .css("z-index", Teva.Positioning.GetNextZIndex())
                .data("modal-backdrop", $Backdrop)
                .data("modal-createdate", new Date())
                .addClass("modal-open");

            document.documentElement.addClass("modal-open-body");
            $(document.body)
                .append($Modal)
                .append($Backdrop);

            Modals.AddVisibleModal($Modal, Params.History_Type, Params.History_Data, Params.PushState);

            var $ModalDialog = $Modal.find(".modal-dialog:first");
            $ModalDialog.fadeIn(200);
            if (Params.ShownEvent != null)
                Params.ShownEvent();
            Modals.PreventDirty_Init($Modal, $Modal.data("ModalID"));
            Common.Tooltip_Hide();

            if (window.event != null && window.event.type == "click")
                window.event.stopPropagation();

            if (!OfficeGuy.Common.IsBrowserLowResolution())
                Teva.Moveable.Enable($Modal, {
                    Container: "body",
                    Handle: ".modal-content-title",
                    Dragged: ".modal-dialog",
                    IsRTL: Common.IsRightToLeft()
                });
        }
        static Hide($Modal, PreventNavigation = false, SkipPreventDirty = false): void {
            $Modal = $($Modal).closest(".modal");
            if ($Modal.hasClass("modal-removed"))
                return;
            $Modal.data("PreventNavigation", PreventNavigation);
            var $PreventDirtyForm = $Modal.find("form.preventdirty:first");
            if (SkipPreventDirty) {
                Forms.ClearDirty($PreventDirtyForm);
                if (window.event != null)
                    window.event.stopPropagation();
            }

            var Params = <CreateModalParams>$Modal.data("modal-params");

            var $IFrame = $("iframe", $Modal);
            if ($IFrame.length > 0 && $IFrame[0].getAttribute("src") != null && $IFrame[0].getAttribute("src").indexOf("https://www.google.com") == -1) {
                try {
                    if (Forms.IsDirty($IFrame.contents().find("form.preventdirty"))) {
                        var ConfirmModal = Forms.DirtyNavigation(function () {
                            Modals.Hide(ConfirmModal);
                            Modals.Hide($Modal);
                        }, $IFrame.contents().find("form.preventdirty"));
                        return;
                    }
                }
                catch (e) {
                }
            }

            if (Forms.IsDirty($PreventDirtyForm)) {
                var ConfirmModal = Forms.DirtyNavigation(function () {
                    Modals.Hide(ConfirmModal);
                    Modals.Hide($Modal);
                }, $PreventDirtyForm);
                return;
            }

            Modals.PreventDirty_Clear($Modal.data("ModalID"));
            $Modal.addClass("modal-removed");
            Modals.RemoveVisibleModal($Modal);
            if (Params != null && Params.HidingEvent != null)
                Params.HidingEvent();
            $Modal.fadeOut(200, function () {
                var $Backdrop = $Modal.data("modal-backdrop");
                if ($Backdrop != null && $Backdrop !== undefined)
                    $Backdrop.remove();
                $Modal.data("modal-backdrop", null)
                $Modal.removeClass("modal-open").remove();
                document.documentElement.removeClass("modal-open-body");
                $('.tooltip').remove();

                if (Params != null && Params.HideEvent != null)
                    Params.HideEvent();
            });
        }

        static HideAll(PreventNavigation = false, HideCallback = null): void {
            var HasModals = $(".modal").length > 0;
            if (HasModals) {
                var Index = 0;
                var $ModalsToHide = $($(".modal").toArray().reverse());
                var HideModalFunction = null;
                HideModalFunction = function () {
                    Modals.Hide($ModalsToHide[Index], PreventNavigation);
                    //$(ModalsToHide[Index]).data("PreventNavigation", PreventNavigation).modal("hide");
                    if (Index < $ModalsToHide.length) {
                        Index++;
                        setTimeout(HideModalFunction, 1);
                    }
                    else if (HideCallback != null)
                        setTimeout(HideCallback, 500);
                };
                HideModalFunction();
            }
            else if (HideCallback)
                HideCallback();
        }

        static AddButton($Modal, Button) {
            $(".modal-buttons", $Modal)
                .append($(document.createElement('div'))
                    .append(Button))
                .show();
        }
        static Create(Params: CreateModalParams): JQuery {
            if (Params.DisableAutoShow == null)
                Params.DisableAutoShow = false;
            if (Params.PushState == null)
                Params.PushState = false;
            if (Params.ModalID == null)
                Params.ModalID = ++Modals.ModalIndex;

            var $Modal = $(document.createElement('div'))
                .attr("tabindex", "-1")
                .attr("role", "dialog")
                .attr("aria-hidden", "true")
                .addClass("modal")
                .addClass(Params.Simple ? "modal-simple" : null)
                .append($(document.createElement('div'))
                    .addClass("modal-dialog")
                    .append($(document.createElement('div'))
                        .addClass("modal-content")
                        .append($(document.createElement('div'))
                            .addClass("modal-content-title")
                            .append(document.createElement('div')
                                .addClass("modal-content-title-text")
                            )
                            .append($(document.createElement('a'))
                                .attr("tabindex", "-1")
                                .addClass("modal-close using-tooltip")
                                .append(document.createElement('span')
                                    .addClass("icon-sumit-close")
                                )
                                .attr("title", OfficeGuy.Resources.GetString("Modal", "Close"))
                                .attr("href", "#")
                                .on("click", function () {
                                    OfficeGuy.Modals.Hide($Modal, false, true);
                                    return false;
                                })
                            )
                        )
                        .append(document.createElement('div')
                            .addClass("modal-body")
                        )
                        .append(document.createElement('div')
                            .addClass("modal-buttons")
                        )
                    )
                );

            $Modal.data("ModalID", Params.ModalID);
            $Modal.data("PushState", Params.PushState);
            $Modal.data("modal-params", Params);
            $(document.body).append($Modal);
            Modals.ToggleIFrameMode($Modal, false);
            Modals.UpdateTitle($Modal, Params.Title);
            Modals.UpdateBody($Modal, Params.Body);
            $(".modal-buttons", $Modal).empty();
            if (Params.Buttons == null)
                $(".modal-buttons", $Modal).hide();
            else {
                for (var i = 0; i < Params.Buttons.length; i++)
                    Modals.AddButton($Modal, Params.Buttons[i]);
            }

            if (Params.EnterEvent != null) {
                $Modal.on("keydown", function (event) {
                    if (event.key != "Enter")
                        return;
                    var Target = <HTMLElement>event.target;
                    if (Target.tagName != "BUTTON" && Target.tagName != "A")
                        return Params.EnterEvent(Target);
                });
            }

            if (!Params.DisableAutoShow)
                Modals.Show($Modal);

            $(document)
                .trigger("click.dropdown-hide")
                .trigger("click.multiplevalues");

            return $Modal;
        }

        static GetModalByModalID(ModalID) {
            var $Modal = null;
            $(".modal").each(function () {
                var $this = $(this);
                if ($this.data("ModalID") == ModalID)
                    $Modal = $this;
            });
            return $Modal;
        }

        static HideModalsAboveModal(ModalID) {
            $(".modal").each(function () {
                var $this = $(this);
                if ($this.data("ModalID") > ModalID)
                    OfficeGuy.Modals.Hide($this, true);
            });
        }

        static AddVisibleModal($Modal, History_Type, History_Data, PushState) {
            Modals.VisibleModals.push($Modal[0]);
            if (PushState) {
                Smooth.StatesCount++;
                if (History_Data == null || History_Data.ConvertToAjax_PreRenderEvent != null || History_Data.LoadedEvent != null || History_Data.Buttons != null)
                    window.history.pushState({ Modal: true, ModalID: $Modal.data("ModalID") }, History_Data == null ? "" : History_Data.Title, History_Data == null ? "" : History_Data.FullURL);
                else
                    window.history.pushState({ Modal: true, ModalID: $Modal.data("ModalID"), Modal_Type: History_Type, Modal_Data: History_Data }, History_Data == null ? "" : History_Data.Title, History_Data == null ? "" : History_Data.FullURL);
            }
        }

        static RemoveVisibleModal($Modal) {
            var Index = Modals.VisibleModals.indexOf($Modal[0]);
            if (Index != -1)
                Modals.VisibleModals.splice(Index, 1);
            if (!$Modal.data("PreventNavigation") && $Modal.data("PushState"))
                window.history.back();
            $(document).trigger("click.SelectBox");
        }

        static ShowConfirmDialog(Params: ConfirmDialogParams): JQuery {
            if (Params.ConfirmText == null || Params.ConfirmText == "")
                Params.ConfirmText = OfficeGuy.Resources.GetString("Modal", "Submit");
            if (Params.CancelText == null || Params.CancelText == "")
                Params.CancelText = OfficeGuy.Resources.GetString("Modal", "Cancel");
            if (Params.ConfirmClass == null)
                Params.ConfirmClass = "og-button-color-submit";
            if (Params.CancelClass == null)
                Params.CancelClass = "og-button-color-default";
            if (Params.Simple == null)
                Params.Simple = true;

            var $Modal;
            var Buttons = new Array();
            if (Params.CancelAllowed == true) {
                Buttons.push($(document.createElement('input'))
                    .addClass("og-button-ui-action")
                    .attr("type", "button")
                    .addClass(Params.CancelClass)
                    .val(Params.CancelText)
                    .on("click", function () {
                        if (Params.CancelEvent != null) {
                            if (typeof (Params.CancelEvent) == "string")
                                Navigation.Redirect(Params.CancelEvent);
                            else {
                                Modals.Hide($Modal);
                                Params.CancelEvent();
                            }
                        }
                        else
                            Modals.Hide($Modal);
                        return false;
                    }));
            }
            Buttons.push($(document.createElement('input'))
                .addClass("og-button-ui-action")
                .attr("type", "button")
                .addClass(Params.ConfirmClass)
                .val(Params.ConfirmText)
                .on("click", function () {
                    if (typeof (Params.ConfirmEvent) == "string")
                        Navigation.Redirect(Params.ConfirmEvent);
                    else {
                        Modals.Hide($Modal);
                        Params.ConfirmEvent();
                    }
                    return false;
                }));

            $Modal = Modals.Create({
                Title: Params.Title,
                Body: Params.Message,
                Buttons: Buttons,
                HidingEvent: Params.HidingEvent,
                HideEvent: Params.HideEvent,
                Simple: Params.Simple
            });
            Modals.ModalLoaded($Modal);
            return $Modal;
        }
        static ShowInputDialog(Params: InputDialogParams): JQuery {
            if (Params.ConfirmText == null || Params.ConfirmText == "")
                Params.ConfirmText = OfficeGuy.Resources.GetString("Modal", "Submit")
            if (Params.InputClass == null)
                Params.InputClass = "input-ShortText";

            var $Input = $(document.createElement('input'))
                .attr("type", "text")
                .addClass(Params.InputClass)
                //.css("width", "100%")
                .val(Params.DefaultValue);
            var $Button = $(document.createElement('a'))
                .addClass("og-button-color-submit")
                .attr("tabindex", "0")
                .on("click", function () {
                    return Params.ConfirmEvent($Input.val());
                });
            $Button
                .addClass("og-button-ui-action")
                .text(Params.ConfirmText)
            var Buttons = [];
            Buttons.push($Button);
            if (Params.Buttons != null)
                for (var i = 0; i < Params.Buttons.length; i++)
                    Buttons.push(Params.Buttons[i]);

            var $Modal = Modals.Create({
                Simple: Params.Simple,
                Title: Params.Title,
                Body: function (BodyContainer) {
                    if (Params.Text != null) {
                        var Text = document.createElement('div');
                        if (Params.TextHTML == true)
                            Text.innerHTML = Params.Text;
                        else
                            Text.innerText = Params.Text;
                        BodyContainer.append(Text);
                    }

                    if (Params.Message) {
                        BodyContainer.append($(document.createElement('div'))
                            .addClass("sumit-field")
                            .append($(document.createElement('div'))
                                .addClass("sumit-field-label")
                                .append($(document.createElement('div'))
                                    .append($(document.createElement('label'))
                                        .attr("for", "InputText")
                                        .text(Params.Message)
                                    )
                                )
                            )
                            .append($(document.createElement('div'))
                                .addClass("sumit-field-value")
                                .append($(document.createElement('div'))
                                    .addClass(Params.InputClass)
                                    .attr("id", "InputText")
                                    .attr("name", "InputText")
                                    .append($Input)
                                )
                            )
                        );
                    }
                    else {
                        BodyContainer.append($(document.createElement('div'))
                            .addClass(Params.InputClass)
                            .attr("id", "InputText")
                            .attr("name", "InputText")
                            .append($Input)
                        );
                    }

                    if (Params.Remark != null) {
                        var Remarks = document.createElement('div');
                        if (Params.RemarkHTML == true)
                            Remarks.innerHTML = Params.Remark;
                        else
                            Remarks.innerText = Params.Remark;
                        BodyContainer.append(Remarks);
                    }
                },
                Buttons: Buttons,
                EnterEvent: function () {
                    $(".og-button-color-submit", $Modal).trigger("click");
                    return false;
                }
            });
            Modals.ModalLoaded($Modal);
            return $Modal;
        }
        static ShowMessageDialog(Title, Message, Button?, Simple?): JQuery {
            if (Simple == null)
                Simple = true;
            var $Modal = Modals.Create({
                Simple: Simple,
                Title: Title,
                Body: Message,
                Buttons: [
                    $(document.createElement('input'))
                        .attr("type", "button")
                        .addClass("og-button-ui-action og-button-color-submit")
                        .val(Button != null ? Button : OfficeGuy.Resources.GetString("Modal", "Submit"))
                        .on("click", function () {
                            Modals.Hide($Modal);
                            return false;
                        })
                ]
            });
            Modals.ModalLoaded($Modal);
            return $Modal;
        }
        static ShowHTMLCloneDialog(Params: HTMLCloneDialog): JQuery {
            if (Params.ReplaceModal == null)
                Params.ReplaceModal = false;

            var $Modal = Modals.Create({
                Title: Params.Title,
                DisableAutoShow: true,
                Simple: Params.Simple
            });
            if (Params.Title == null)
                $(".og-navigation-bar:first", $Modal).remove();
            if (Params.ReplaceModal) {
                $(".modal-content > *:not(.close)", $Modal).remove();
                $(".modal-content", $Modal).prepend($(Params.Selector).clone(true, true).show());
            }
            else
                Modals.UpdateBody($Modal, $(Params.Selector).clone(true, true).show());
            $(document).trigger("OG.ModalLoading", $Modal);
            Modals.Show($Modal);
            Modals.ModalLoaded($Modal);
            return $Modal;
        }
        static ModalLoaded($Modal) {
            OfficeGuy.Common.InitEditors($Modal);
            if (!Common.IsBrowserLowResolution()) {
                if ($Modal.hasClass("modal-simple"))
                    $Modal.find(".modal-buttons").find("a, input").last().trigger('focus');
                else
                    Teva.Navigation.FocusOnFirstField($Modal);
            }
        }

        static ShowHTMLDialog(Params: HTMLDialogParams): JQuery {
            var Buttons = Params.Buttons || []; // Should clone Buttons
            if (Params.ShowSubmitButton) {
                Buttons.push($(document.createElement('input'))
                    .attr("type", "button")
                    .addClass("og-button-ui-action og-button-color-submit")
                    .val(OfficeGuy.Resources.GetString("Modal", "Submit"))
                    .on("click", function () {
                        Modals.Hide($Modal);
                        return false;
                    }));
            }
            var OriginalParent = Params.HTML instanceof jQuery ? $(Params.HTML).parent() : null;
            var $Modal = Modals.Create({
                Simple: Params.Simple,
                Title: Params.Title,
                Body: Params.HTML,
                DisableAutoShow: true,
                HidingEvent: function () {
                    if (OriginalParent != null)
                        OriginalParent.append(Params.HTML);
                    if (Params.HidingEvent)
                        Params.HidingEvent();
                },
                HideEvent: function () {
                    if (Params.HideEvent)
                        Params.HideEvent();
                },
                Buttons: Buttons,
                EnterEvent: Params.EnterEvent
            });
            if (Params.Title == null)
                $(".og-navigation-bar:first", $Modal).remove();
            $(document).trigger("OG.ModalLoading", $Modal);
            Modals.Show($Modal);
            Modals.ModalLoaded($Modal);
            return $Modal;
        }
        static ShowHTMLGetDialog(Params: HTMLGetDialogParams): JQuery {
            if (Params.ConvertToAjax == null)
                Params.ConvertToAjax = false;
            if (Params.ReplaceModal == null)
                Params.ReplaceModal = false;
            if (Params.Method == null)
                Params.Method = "GET";

            Navigation.Loading_Show();
            var ModalParams = {
                Title: Params.Title,
                History_Type: "ShowHTMLGetDialog",
                History_Data: Params,
                Buttons: Params.Buttons,
                DisableAutoShow: true,
                PushState: Params.PushState,
                ModalID: Params.ModalID,
                HideEvent: Params.HideEvent,
                Simple: Params.Simple
            };
            var $Modal = Modals.Create(ModalParams);
            if (Params.Title == null)
                $(".og-navigation-bar:first", $Modal).remove();

            $.ajax({
                url: Params.URL,
                data: Params.Data,
                headers: { "x-modal": "1" },
                method: Params.Method,
                error: function (Request, Status, Exception) {
                    OfficeGuy.Common.AjaxError(Request, Status, Exception);
                    Navigation.Loading_Hide();
                },
                success: function (Response, StatusText, jqXHR) {
                    if (typeof (Response) != "string") {
                        if (Response.ErrorMessage != null) {
                            setTimeout(function () {
                                var $NotificationText = $(document.createElement('div'))
                                    .html(Response.ErrorMessage)
                                    .addClass("og-notification-modal-color-danger");
                                Modals.ShowMessageDialog(Response.ErrorTitle == null ? "הודעת מערכת" : Response.ErrorTitle, $NotificationText, Response.ErrorButton);
                            }, 200);
                        }
                        if (Response.RedirectURL !== undefined) {
                            if (Response.RedirectURL == ".")
                                window.location.reload();
                            else if (Response.FullRefresh)
                                window.location.href = Response.RedirectURL;
                            else
                                Navigation.Redirect(Response.RedirectURL, Response.AllowRedirectModal == false);
                        }
                        Navigation.Loading_Hide();
                        return;
                    }

                    OfficeGuy.ExternalProvider.PageLoad(Params.URL);
                    if (Params.ReplaceModal)
                        $(".modal-content", $Modal).empty().prepend(Response);
                    else
                        Modals.UpdateBody($Modal, Response);

                    ModalParams.PushState = jqXHR.getResponseHeader("x-modalstate") != "skip";
                    if (jqXHR.getResponseHeader("x-modal-simple") == "1") {
                        ModalParams.Simple = true;
                        $Modal.addClass("modal-simple");
                    }
                    $Modal.data("PushState", ModalParams.PushState);

                    Forms.ParseDynamicContent_Init();
                    (<any>$.validator).unobtrusive.parseDynamicContent($Modal);
                    $(document).trigger("OG.ModalLoading", $Modal);
                    Modals.Show($Modal);
                    Modals.ModalLoaded($Modal);
                    Navigation.Loading_Hide();
                    if (Params.ConvertToAjax) {
                        if (Params.ReplaceModal)
                            Forms.ConvertFormToAjax($("form", $Modal), $(".modal-content", $Modal), Params.ConvertToAjax_PreRenderEvent, true);
                        else
                            Forms.ConvertFormToAjax($("form", $Modal), $(".modal-body", $Modal), Params.ConvertToAjax_PreRenderEvent, true);
                    }
                    if (Params.LoadedEvent != null)
                        Params.LoadedEvent();
                }
            });
            return $Modal;
        }

        static ThumbnailsToModal(Selector) {
            $("> a", Selector)
                .off("click.og-thumbnails")
                .on("click.og-thumbnails", function () {
                    Modals.ShowImagesModal(Selector, $(this));
                    return false;
                });
        }

        static ShowImagesModal(Selector, $Link) {
            var $Image = $("img", $Link);

            var Modal;

            var AllImages = new Array();
            var VisibleIndex = 0;
            $("a", Selector).each(function (Index) {
                if (this == $Link[0])
                    VisibleIndex = Index;
                AllImages.push({
                    Title: $("img", this)[0].getAttribute("alt"),
                    Href: this.getAttribute("href")
                });
            });

            var $Container = $(document.createElement('div'))
                .addClass("og-thumbnails-modal");

            Navigation.Loading_Show(false);
            var $VisibleImage = $(document.createElement('img'))
                .addClass("og-thumbnails-modal-image")
                .attr("src", $Link[0].getAttribute("href"))
                .on("load", function () {
                    Navigation.Loading_Hide();
                })
                .on("click", function (Event) {
                    if (Event.ctrlKey || Event.shiftKey) {
                        var Path = this.src;
                        if (Path.indexOf("/") == 0)
                            Path = OfficeGuy.Common.FullRootURL + Path;
                        window.open(Path);
                        return false;
                    }

                    VisibleIndex = (VisibleIndex + 1) % AllImages.length;
                    if (AllImages.length < 2)
                        return false;

                    return RefreshImage();
                })
                .appendTo($Container);

            function RefreshImage() {
                var NextImage = AllImages[VisibleIndex];
                OfficeGuy.Modals.UpdateTitle(Modal, NextImage.Title);

                Navigation.Loading_Show(false);
                $VisibleImage[0].src = NextImage.Href;

                return false;
            }

            $Container.append($(document.createElement('div'))
                .addClass("og-thumbnails-modal-popup using-tooltip")
                .attr("title", "פתיחה בחלון חדש")
                .on("click", function () {
                    var Path = $VisibleImage[0].src;
                    if (Path.indexOf("/") == 0)
                        Path = OfficeGuy.Common.FullRootURL + Path;
                    window.open(Path);
                    return false;
                }));
            if (AllImages.length > 1) {
                $Container.append($(document.createElement('div'))
                    .addClass("og-thumbnails-modal-previous")
                    .on("click", function () {
                        VisibleIndex = ((VisibleIndex - 1) + AllImages.length) % AllImages.length;
                        return RefreshImage();
                    }));
                $Container.append($(document.createElement('div'))
                    .addClass("og-thumbnails-modal-next")
                    .on("click", function () {
                        VisibleIndex = (VisibleIndex + 1) % AllImages.length;
                        return RefreshImage();
                    }));
            }

            Modal = OfficeGuy.Modals.ShowHTMLDialog({
                Title: $Image.attr("alt"),
                HTML: $Container,
                HideEvent: function () {
                    $(window).off("resize.imagesmodal");
                    $(document).off("keydown.imagesmodal");
                }
            });
            $(".modal-body", Modal).css("padding", "0px");
            var ResizeImage = function () {
                var MaximumHeight = $(window).height() - 120;
                MaximumHeight -= $(".og-navigation-bar", Modal).outerHeight();
                MaximumHeight -= 20;
                if (MaximumHeight < 200)
                    MaximumHeight = 200;
                $VisibleImage.css("max-height", MaximumHeight);
            };
            ResizeImage();
            $(window)
                .off("resize.imagesmodal")
                .on("resize.imagesmodal", ResizeImage);
            $(document)
                .off("keydown.imagesmodal")
                .on("keydown.imagesmodal", function (Event) {
                    if (Event.key == "ArrowLeft") {
                        VisibleIndex = (VisibleIndex + 1) % AllImages.length;
                        Event.preventDefault();
                        return RefreshImage();
                    }
                    else if (Event.key == "ArrowRight") {
                        VisibleIndex = ((VisibleIndex - 1) + AllImages.length) % AllImages.length;
                        Event.preventDefault();
                        return RefreshImage();
                    }
                });

            return false;
        }

        static ToggleIFrameMode($Modal, IsIFrame: boolean): void {
            if (IsIFrame)
                $Modal.addClass("modal-iframe");
            else
                $Modal.removeClass("modal-iframe");
        }
        static CloseIFramePopup(RedirectURL?): void {
            (<any>window.parent).closeModal();
            if (RedirectURL != null)
                window.parent.location.href = RedirectURL;
        }

        static PreventDirty_Init($Modal, ModalID) {
            var $PreventDirtyForm = $Modal.find("form.preventdirty");
            if ($PreventDirtyForm.length == 0)
                return;

            Modals.PreventDirty_Clear(ModalID);
            if ($PreventDirtyForm.length > 0) {
                $PreventDirtyForm
                    .on("change.preventdirty", function (Event) {
                        var Tag = (<Element>Event.target).tagName;
                        if (Tag == "INPUT" || Tag == "SELECT" || Tag == "TEXTAREA")
                            Forms.SetDirty($(this));
                    })
                    .on("submit.preventdirty", function () {
                        $(this)
                            .data("og-modified", false)
                            .off("change.preventdirty");
                    });

                $(window).on("beforeunload.preventdirty_modal_" + ModalID, function (Event) {
                    if (Forms.IsDirty($PreventDirtyForm))
                        return (<any>Event).returnValue = OfficeGuy.Resources.GetString("CRM", "UnsavedWarning");
                });
            }
        }
        static PreventDirty_Clear(ModalID) {
            $(window).off("beforeunload.preventdirty_modal_" + ModalID);
        }

        static ShowURLModal(URL) {
            return Modals.ShowHTMLGetDialog({
                URL: URL,
                FullURL: URL,
                ReplaceModal: true,
                ConvertToAjax: true
            });
        }
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.Modals.Init();
});

$(document).on("Teva.PageLoad", function () {
    OfficeGuy.Modals.PageLoad();
});

(<any>window).ParentModalCloseButtons = new Array();
